export const currencyformatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
})

export const decimalformatter = new Intl.NumberFormat('de-DE', {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const dateoptions = {
  timeZone: 'Europe/Berlin',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
}
export const dateformatter = new Intl.DateTimeFormat('de-DE', dateoptions)

const monthoptions = {
  timeZone: 'Europe/Berlin',
  month: 'long',
}
export const monthformatter = new Intl.DateTimeFormat('de-DE', monthoptions)

const timeoptions = {
  timeZone: 'Europe/Berlin',
  hour: 'numeric',
  minute: 'numeric',
  hour12: false,
}
export const timeformatter = new Intl.DateTimeFormat('de-DE', timeoptions)
